import { useEffect, useRef } from 'react';
import { useRouterState } from '@tanstack/react-router';
import { posthog } from '../lib/posthog';

export function PostHogPageviewTracker() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const isFirst = useRef(true);
  const prevPathname = useRef(pathname);

  useEffect(() => {
    if (isFirst.current || pathname !== prevPathname.current) {
      isFirst.current = false;
      prevPathname.current = pathname;
      posthog.capture('$pageview');
    }
  }, [pathname]);

  return null;
}
